import image1 from 'shared/assets/images/integrationsSliders/agentforce/agentforce1.png'
import image2 from 'shared/assets/images/integrationsSliders/agentforce/agentforce2.png'
import { LINK_AGENTFORCE_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const agentforce: IntegrationDetailsData = {
  subheadline: 'Ask, retrieve and explore SMS conversation history inside Agentforce.',
  overview:
    'Salesmsg integrates with Salesforce Agentforce, bringing your SMS conversation history directly into the AI agent experience. The Agentforce agent recognizes the active contact in Salesforce, retrieves their Salesmsg conversations, and answers your questions about those interactions – all without leaving your CRM.',
  keyBenefits: [
    'Automatically identify the active Salesforce contact and pull their SMS conversations from Salesmsg.',
    'Ask the agent any question about a contact’s conversation history.',
    'Get instant, context-aware answers to make data-driven decisions.',
    'Generate ready-to-send message drafts tailored to each contact based on your communication preferences.',
  ],
  images: [image1, image2],
  docs: LINK_AGENTFORCE_INTEGRATION_GUIDE,
}
